import React, { ForwardedRef, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { Merge } from '../../src/utils/types'

export interface CoreListProps {
  className?: string | undefined
  ordered?: boolean | undefined
}

type ListProps = Merge<React.ComponentProps<'ul'>, CoreListProps>

export const List = forwardRef(function List(
  { className, children, ordered = false, ...passthroughProps }: ListProps,
  ref: ForwardedRef<HTMLUListElement | HTMLOListElement>
) {
  const listClassName = twMerge(
    ordered ? 'list-decimal' : 'list-disc',
    'pl-6 space-y-1 mb-4 text-base tracking-wide text-black',
    className
  )
  // The same forwarded ref serves both tags, and passthroughProps carries a
  // ul-typed ref from ComponentProps<'ul'>, so this stays loosely typed.
  if (ordered) {
    return (
      <ol ref={ref as any} {...passthroughProps} className={listClassName}>
        {children}
      </ol>
    )
  }
  return (
    <ul ref={ref as any} {...passthroughProps} className={listClassName}>
      {children}
    </ul>
  )
})

export default List
